(function($,w,d){

    function resolveScope( scope )
    {

        if ( scope && scope.jquery )
            return scope;

        if ( scope )
            return $( scope );

        return $( d );

    }

    function syncGroup( group )
    {

        let input = group.find( '.ff-el-form-control' ).first(),
            hasValue = !! ( input.val() && String( input.val() ).trim().length );

        group.toggleClass( 'has-value', hasValue );

    }

    function setValidationNonce( scope )
    {
        let userInfo = w.idUserInfo || ( 'undefined' != typeof idUserInfo ? idUserInfo : false ),
            nonce = userInfo && userInfo.nonce ? String( userInfo.nonce ) : '';

        if ( '' === nonce )
            return;

        scope.find( 'form.frm-fluent-form' ).each( function()
        {
            let form = $( this );

            // Sales/booking forms use `validate` for encrypted price options, not the runtime nonce.
            if ( form.find( 'input[name="prices"]' ).length && form.find( 'input[name="toPay"]' ).length )
                return;

            form.find( 'input[name="validate"]' ).val( nonce );

        });

    }

    function adjustHelp( scope )
    {

        scope.find( 'div.helptxt' ).each(function ()
        {

            let t = $( this ),
                help = t.find( 'div.ff-el-help-message' );

            if ( ! help.length )
                return;

            let baseMb = parseInt( t.data( 'base-mb' ) || t.css( 'marginBottom' ) ) || 0,
                extra = help.outerHeight() + 5;

            t.css( 'marginBottom', baseMb + extra );

            help.css({
                'position': 'absolute',
                'zIndex': 0,
            });

            if ( ! t.data( 'base-mb' ) )
                t.data( 'base-mb', baseMb );

        });

    }

    function initForms( scope )
    {
        scope = resolveScope( scope );

        scope.find( 'div.fluentform' ).each( function()
        {
            let form = $( this );

            form.find( 'form.white-form' ).parent( 'div' ).addClass( 'white-form' );

            form.find( '.ff-el-group' ).not( '.default' ).each( function()
            {

                let group = $( this ),
                    input = group.find( '.ff-el-form-control' );

                if ( '1' !== group.attr( 'data-wwl-form-group-init' ) )
                {

                    input.on( 'focus', function(){ group.addClass( 'is-focus' ); });
                    input.on( 'blur',  function(){ group.removeClass( 'is-focus' ); syncGroup( group ); });
                    input.on( 'input change', function(){ syncGroup( group ); });
                    group.attr( 'data-wwl-form-group-init', '1' );

                }

                syncGroup( group );

            });

        });

        setValidationNonce( scope );
        adjustHelp( scope );

    }

    w.wwlFormsInit = initForms;

    $(function()
    {

        initForms( d );
        $( w ).on( 'resize', function(){ adjustHelp( $( d ) ); });
        $( d ).on( 'fluentform_init', function( e, data ){ initForms( data && data[0] ? data[0] : d ); });

    });

})(jQuery,window,document);
